<div class="field-mapping-modal">
  <div class="modal-header">
    <h3>Mapear Campos Derivados</h3>
    <p class="help-text" *ngIf="isSearchField">
      Ao selecionar um item na pesquisa, preencha automaticamente outros campos do formulário
      com colunas da linha selecionada na entidade <strong>{{ entityName }}</strong>.
    </p>
    <p class="help-text" *ngIf="!isSearchField">
      Ao alterar o valor deste campo, propagar automaticamente para outros campos do formulário.
    </p>
  </div>

  <div class="modal-content">
    <!-- Lista de mapeamentos -->
    <div class="mapping-list" *ngIf="items.length > 0">
      <div *ngFor="let item of items; let i = index; trackBy: trackByIndex" class="mapping-item">
        <div class="mapping-row">
          <div class="mapping-field" *ngIf="isSearchField">
            <label class="mapping-label">Coluna de origem (entidade)</label>
            <input nz-input [(ngModel)]="item.sourceColumn"
              [placeholder]="'builderScreen.fieldMapping.sourcePlaceholder' | translateTA" nzSize="small" />
          </div>

          <div class="mapping-arrow" *ngIf="isSearchField">
            <nz-icon nzType="arrow-right" nzTheme="outline"></nz-icon>
          </div>

          <div class="mapping-field" [style.flex]="isSearchField ? null : '1'">
            <label class="mapping-label">{{ 'builderScreen.fieldMapping.targetField' | translateTA }}</label>
            <nz-select [(ngModel)]="item.targetDataPath"
              (ngModelChange)="onTargetChange(item)"
              [nzPlaceHolder]="'builderScreen.fieldMapping.selectField' | translateTA"
              nzSize="small"
              nzShowSearch
              style="width: 100%;">
              <nz-option *ngFor="let target of availableTargets"
                [nzValue]="target.dataPath"
                [nzLabel]="target.label + ' (' + target.dataPath + ')'">
              </nz-option>
            </nz-select>
          </div>

          <button nz-button nzType="text" nzDanger nzSize="small"
            (click)="removeMapping(i)" nz-tooltip [nzTooltipTitle]="'builderScreen.common.remove' | translateTA">
            <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Mensagem vazia -->
    <nz-empty *ngIf="items.length === 0"
      [nzNotFoundContent]="'builderScreen.fieldMapping.empty' | translateTA">
    </nz-empty>

    <!-- Botão adicionar -->
    <button nz-button nzType="dashed" nzBlock (click)="addMapping()" style="margin-top: 12px;">
      <nz-icon nzType="plus"></nz-icon>
      Adicionar Mapeamento
    </button>
  </div>

  <div class="modal-footer">
    <span class="footer-info" *ngIf="validCount > 0">
      {{ validCount }} mapeamento(s) configurado(s)
    </span>
    <button nz-button nzType="default" (click)="handleCancel()">Cancelar</button>
    <button nz-button nzType="primary" (click)="handleOk()">Salvar</button>
  </div>
</div>
